import { IntegrationUsageLogWhere, useIntegrationUsageLogStatsQuery } from 'src/api';

export const useIntegrationUsageLogStats = (filter: IntegrationUsageLogWhere) => {
  const { data, loading, refetch } = useIntegrationUsageLogStatsQuery({
    variables: { filter },
    notifyOnNetworkStatusChange: true,
  });

  return {
    stats: data?.getIntegrationUsageLogStats,
    loading,
    refetch,
  };
};
